/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { FILE_LIST_FILTER } from '@/modules/base/util/constants'
import ThemeInterface from '@/theme-interface'
import { useSelector } from 'react-redux'
import { orderBy } from 'lodash'
import clsx from 'clsx'
import { Folder } from '@/modules/file/components/folder-nav/types'
import FolderItem, { isCurrentPath } from '@/modules/file/components/folder-nav/folder-item'

type Props = {
  folder: Folder,
  rootLevel?: boolean,
  depth?: number,
  onHover?: (x: any) => void,
  activeFilter: keyof typeof FILE_LIST_FILTER,
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    background: theme.white,
    maxWidth: '100%',
  },
  rootLevel: {
    borderBottom: theme.border,
  },
}), { name: 'FolderNavTree' })

const FolderNavTree = (props: Props) => {
  const classes = useStyles()

  const { folder, activeFilter, rootLevel, onHover, depth = 0 } = props

  const {
    currentFolder,
  } = useSelector((state: any) => state.document.list)

  const [open, setOpen] = useState(isCurrentPath(currentFolder, folder))

  useEffect(() => {
    const isOpen = isCurrentPath(currentFolder, folder)
    if (isOpen) {
      setOpen(isOpen)
    }
  }, [currentFolder.id])

  const sort = (items) => {
    return orderBy(items, ['name'], ['asc'])
  }

  const children = useMemo(() => sort(folder.children), [folder.children])

  return (
    <div className={clsx(classes.root, { [classes.rootLevel]: rootLevel })}>
      <FolderItem
        showToggle
        onHover={onHover}
        open={open}
        folder={folder}
        activeFilter={activeFilter}
        setOpen={setOpen}
        depth={depth}
      />
      {open
        ? children.map((child, i) => (<div key={`navTree${i}`}>
          <FolderNavTree onHover={onHover} folder={child} activeFilter={activeFilter} depth={depth + 1} />
        </div>))
        : null}
    </div>
  )
}

export default FolderNavTree
